module.exports = __webpack_public_path__ + "img/26_180.457d5428.png";